import { PageAdminDto } from '../../../../services/dtos/page-admin.dto';
import { object, string } from 'yup';
import { Grid, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../../commun/input-form';
import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomButton from '../../../commun/custom-button';

function getPageAdminLabel(pageKey: string): string {
    switch (pageKey) {
        case 'politique-confidentialite':
            return 'Politique de Confidentialité';
        case 'mentions-legales':
        default:
            return 'Mentions légales';
    }
}

/**
 * Form pour pour les pages dynamiques
 * @param props props handler, loading, page
 * @constructor
 */
export default function PageAdminForm(
    props: Readonly<{
        handlerSubmit: (e: PageAdminDto) => void;
        loading: boolean;
        page: PageAdminDto;
    }>
) {
    // Contenu entré dans l'éditeur de texte, prend à l'initialisation la valeur actuelle du champ
    const [content, setContent] = useState(props.page.content);

    useEffect(() => {
        setContent(props.page.content);
    }, [props.page.content]);

    // Définition des règles de validation
    const validationSchema = object({
        title: string().required('Le titre est obligatoire'),
        content: string().required('Un contenu est obligatoire'),
    });

    //Intitialisation des valeurs
    const initValues = {
        id: props.page.id,
        key: props.page.key,
        title: props.page.title,
        content: content,
    };

    // Handle submit function.
    const handleSubmit = (data: PageAdminDto): void => {
        data = {
            ...data,
            content: content,
        };
        props.handlerSubmit(data);
    };

    const pageLabel = getPageAdminLabel(props.page.key);

    return (
        // Formulaire
        <Formik
            initialValues={initValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            enableReinitialize
        >
            <Form>
                <Typography variant="h2">Modification des données de la page "{pageLabel}"</Typography>
                <Grid container rowSpacing={2}>
                    <Grid item xs={0} sm={2} />
                    <Grid item xs={12} sm={8}>
                        {/*Champ texte Titre*/}
                        <InputForm id="title" name="title" label="Titre de la page" required />
                    </Grid>
                    <Grid item xs={0} sm={2} />
                    <Grid item xs={0} sm={2} />
                    <Grid item xs={12} sm={8}>
                        <Typography variant="h5">Contenu de la page : </Typography>
                        <ReactQuill theme="snow" value={content} onChange={setContent} />
                    </Grid>
                    <Grid item xs={0} sm={2} />
                    <Grid item xs={0} sm={3} />
                    <Grid item xs={6} className="double-btn">
                        <Typography variant={'button'}>
                            <CustomButton label="Annuler" variant="neutral" componentLink={true} to={'/'} />
                        </Typography>
                        <Typography variant={'button'}>
                            <CustomButton
                                label={'Enregistrer'}
                                disabled={props.loading}
                                type={'submit'}
                                variant={'contained'}
                            />
                        </Typography>
                    </Grid>
                    <Grid item xs={0} sm={3} />
                </Grid>
            </Form>
        </Formik>
    );
}
